export { default as Carousel } from './lib/Carousel';
export type { CarouselBreakpoints, CarouselProps } from './lib/Carousel';
